import React from 'react';
import { styled } from 'linaria/react';
import { Typography } from 'fronton-react';
import { EmptyScreen } from './empty-screen';
import { breakpoints } from '../../../media';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 64px;
	padding-block: 80px;
	margin-block: 48px;
	& h3 {
		text-align: center;
	}

	${breakpoints.to.largeDesktop} {
		margin-top: 32px;
	}
	${breakpoints.to.desktop} {
		margin-block: 32px;
		padding-block: 40px;
	}
	${breakpoints.to.tablet} {
		margin-block: 24px;
		padding-block: 40px;
		padding-inline: 30px;
	}
`;

export const NotFound = ({ description }) => (
	<Wrapper>
		<EmptyScreen />
		<Typography variant="h3" as="h3">
			{description}
		</Typography>
	</Wrapper>
);
